"use strict";

var _classCallCheck = require("/code/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/code/node_modules/@babel/runtime/helpers/createClass");

var _defineProperty = require("/code/node_modules/@babel/runtime/helpers/defineProperty");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e10) { throw _e10; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e11) { didErr = true; err = _e11; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcMetrics = b;
exports.copyContent = w;
exports.run = p;
exports.RUNNER_VERSION = void 0;
var e = {
  preferredElementNodeName: 'PRE',
  render: function render(e, s) {
    var i = e.settings.element;
    e.rows == n && e.cols == o || (o = e.cols, n = e.rows, t.length = 0);

    for (; i.childElementCount < n;) {
      var _e = document.createElement('span');

      _e.style.display = 'block', i.appendChild(_e);
    }

    for (; i.childElementCount > n;) {
      i.removeChild(i.lastChild);
    }

    for (var _c = 0; _c < n; _c++) {
      var _n = _c * o;

      var _a = !1;

      for (var _e2 = 0; _e2 < o; _e2++) {
        var _o = _e2 + _n,
            _l = s[_o],
            _i = t[_o];

        r(_l, _i) || (_a = !0, t[_o] = _objectSpread({}, _l));
      }

      if (0 == _a) continue;

      var _d = '',
          _f = {},
          _h = !1;

      for (var _t = 0; _t < o; _t++) {
        var _o2 = s[_t + _n];

        if (_o2.beginHTML && (_h && (_d += '</span>', _f = {}, _h = !1), _d += _o2.beginHTML), !l(_o2, _f)) {
          _h && (_d += '</span>');

          var _t2 = _o2.color === e.settings.color ? null : _o2.color,
              _n2 = _o2.backgroundColor === e.settings.backgroundColor ? null : _o2.backgroundColor,
              _r = _o2.fontWeight === e.settings.fontWeight ? null : _o2.fontWeight;

          var _l2 = '';
          _t2 && (_l2 += 'color:' + _t2 + ';'), _n2 && (_l2 += 'background:' + _n2 + ';'), _r && (_l2 += 'font-weight:' + _r + ';'), _l2 && (_l2 = ' style="' + _l2 + '"'), _d += '<span' + _l2 + '>', _h = !0;
        }

        _d += _o2.char, _f = _o2, _o2.endHTML && (_h && (_d += '</span>', _f = {}, _h = !1), _d += _o2.endHTML);
      }

      _h && (_d += '</span>'), i.childNodes[_c].innerHTML = _d;
    }
  }
};
var t = [];
var o, n;

function r(e, t) {
  return 'object' == typeof e && 'object' == typeof t && e.char === t.char && e.fontWeight === t.fontWeight && e.color === t.color && e.backgroundColor === t.backgroundColor;
}

function l(e, t) {
  return e.fontWeight === t.fontWeight && e.color === t.color && e.backgroundColor === t.backgroundColor;
}

var s = {
  preferredElementNodeName: 'CANVAS',
  render: function render(e, t) {
    var o = e.settings.element,
        n = devicePixelRatio,
        r = e.cols,
        l = e.rows,
        s = e.metrics,
        i = s.cellWidth,
        c = Math.round(s.lineHeight),
        a = e.settings;
    a.canvasSize ? (o.width = a.canvasSize.width * n, o.height = a.canvasSize.height * n, o.style.width = a.canvasSize.width + 'px', o.style.height = a.canvasSize.height + 'px') : (o.width = e.width * n, o.height = e.height * n);
    var d = ' ' + s.fontSize + 'px ' + s.fontFamily,
        f = a && a.backgroundColor ? a.backgroundColor : 'white',
        h = a && a.color ? a.color : 'black',
        u = a && a.fontWeight ? a.color : '400',
        p = o.getContext('2d');

    if (p.fillStyle = f, p.fillRect(0, 0, o.width, o.height), p.save(), p.scale(n, n), p.fillStyle = h, p.textBaseline = 'top', a.canvasOffset) {
      var _e3 = a.canvasOffset,
          _t3 = Math.round('auto' == _e3.x ? (o.width / n - r * i) / 2 : _e3.x),
          _s = Math.round('auto' == _e3.y ? (o.height / n - l * c) / 2 : _e3.y);

      p.translate(_t3, _s);
    }

    if ('center' == a.textAlign) for (var _e4 = 0; _e4 < l; _e4++) {
      var _l3 = _e4 * r,
          _s2 = [];

      var _i2 = 0;

      for (var _e5 = 0; _e5 < r; _e5++) {
        var _o3 = t[_l3 + _e5];
        p.font = (_o3.fontWeight || u) + d;
        var _n3 = p.measureText(_o3.char).width;
        _i2 += _n3, _s2[_e5] = _n3;
      }

      var _a2 = 0.5 * (o.width / n - _i2);

      var _g = _e4 * c;

      for (var _e6 = 0; _e6 < r; _e6++) {
        var _o4 = t[_l3 + _e6],
            _n4 = _a2;
        _o4.backgroundColor && _o4.backgroundColor != f && (p.fillStyle = _o4.backgroundColor || f, p.fillRect(Math.round(_n4), _g, Math.ceil(_s2[_e6]), c)), p.font = (_o4.fontWeight || u) + d, p.fillStyle = _o4.color || h, p.fillText(_o4.char, _a2, _g), _a2 += _s2[_e6];
      }
    } else for (var _e7 = 0; _e7 < l; _e7++) {
      for (var _o5 = 0; _o5 < r; _o5++) {
        var _n5 = t[_e7 * r + _o5],
            _l4 = _o5 * i,
            _s3 = _e7 * c;

        _n5.backgroundColor && _n5.backgroundColor != f && (p.fillStyle = _n5.backgroundColor || f, p.fillRect(Math.round(_l4), _s3, Math.ceil(i), c)), p.font = (_n5.fontWeight || u) + d, p.fillStyle = _n5.color || h, p.fillText(_n5.char, _l4, _s3);
      }
    }
    p.restore();
  }
};

var i = /*#__PURE__*/function () {
  function i() {
    _classCallCheck(this, i);

    this.frames = 0, this.ptime = 0, this.fps = 0;
  }

  _createClass(i, [{
    key: "update",
    value: function update(e) {
      return this.frames++, e >= this.ptime + 1e3 && (this.fps = 1e3 * this.frames / (e - this.ptime), this.ptime = e, this.frames = 0), this.fps;
    }
  }]);

  return i;
}();

var c = function c(e, t) {
  try {
    return localStorage.setItem(e, JSON.stringify(t)), !0;
  } catch (e) {
    return !1;
  }
},
    a = function a(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var o = JSON.parse(localStorage.getItem(e));
  return Object.assign(t, o), t;
},
    d = '1.1';

exports.RUNNER_VERSION = d;
var f = {
  canvas: s,
  text: e
},
    h = {
  element: null,
  cols: 0,
  rows: 0,
  once: !1,
  fps: 30,
  renderer: 'text',
  allowSelect: !1,
  restoreState: !1
},
    u = ['backgroundColor', 'color', 'fontFamily', 'fontSize', 'fontWeight', 'letterSpacing', 'lineHeight', 'textAlign'];

function p(e, t) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise(function (n) {
    var r = _objectSpread(_objectSpread(_objectSpread({}, h), t), e.settings),
        l = {
      time: 0,
      frame: 0,
      cycle: 0
    },
        s = 'currentState';

    var d;
    r.restoreState && (a(s, l), l.cycle++), r.element ? 'canvas' == r.renderer ? 'CANVAS' == r.element.nodeName ? d = f[r.renderer] : console.warn('This renderer expects a canvas target element.') : 'CANVAS' != r.element.nodeName ? d = f[r.renderer] : console.warn('This renderer expects a text target element.') : (d = f[r.renderer] || f.text, r.element = document.createElement(d.preferredElementNodeName), document.body.appendChild(r.element));

    var _iterator = _createForOfIteratorHelper(u),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e9 = _step.value;
        r[_e9] && (r.element.style[_e9] = r[_e9]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var p = [],
        m = {
      x: 0,
      y: 0,
      pressed: !1,
      px: 0,
      py: 0,
      ppressed: !1
    };
    r.element.addEventListener('pointermove', function (e) {
      var t = r.element.getBoundingClientRect();
      m.x = e.clientX - t.left, m.y = e.clientY - t.top, p.push('pointerMove');
    }), r.element.addEventListener('pointerdown', function (e) {
      m.pressed = !0, p.push('pointerDown');
    }), r.element.addEventListener('pointerup', function (e) {
      m.pressed = !1, p.push('pointerUp');
    }), r.element.style.fontStrech = 'normal', r.allowSelect || y(r.element), document.fonts.ready.then(function (t) {
      var n = 3;
      !function t() {
        --n > 0 ? requestAnimationFrame(t) : function () {
          x = b(r.element);
          var t = g(l, r, x, w);
          'function' == typeof e.boot && e.boot(t, C, o);
          requestAnimationFrame(M);
        }();
      }();
    });
    var w = new i(),
        S = Object.freeze({
      color: r.color,
      backgroundColor: r.backgroundColor,
      fontWeight: r.fontWeight
    }),
        C = [];
    var x;
    var v = 0;
    var k = 1e3 / r.fps,
        N = l.time;
    var E, W;

    function M(t) {
      var i = t - v;
      if (i < k) return void (r.once || requestAnimationFrame(M));
      var a = g(l, r, x, w);
      w.update(t), v = t - i % k, l.time = t + N, l.frame++, c(s, l);
      var f = {
        x: Math.min(a.cols - 1, m.x / x.cellWidth),
        y: Math.min(a.rows - 1, m.y / x.lineHeight),
        pressed: m.pressed,
        p: {
          x: m.px / x.cellWidth,
          y: m.py / x.lineHeight,
          pressed: m.ppressed
        }
      };

      if (m.px = m.x, m.py = m.y, m.ppressed = m.pressed, E != a.cols || W != a.rows) {
        E = a.cols, W = a.rows, C.length = a.cols * a.rows;

        for (var _e8 = 0; _e8 < C.length; _e8++) {
          C[_e8] = _objectSpread(_objectSpread({}, S), {}, {
            char: ' '
          });
        }
      }

      if ('function' == typeof e.pre && e.pre(a, f, C, o), 'function' == typeof e.main) for (var _t4 = 0; _t4 < a.rows; _t4++) {
        var _n6 = _t4 * a.cols;

        for (var _r2 = 0; _r2 < a.cols; _r2++) {
          var _l5 = _r2 + _n6,
              _s4 = e.main({
            x: _r2,
            y: _t4,
            index: _l5
          }, a, f, C, o);

          C[_l5] = 'object' == typeof _s4 && null !== _s4 ? _objectSpread(_objectSpread({}, C[_l5]), _s4) : _objectSpread(_objectSpread({}, C[_l5]), {}, {
            char: _s4
          }), Boolean(C[_l5].char) || 0 === C[_l5].char || (C[_l5].char = ' ');
        }
      }

      for ('function' == typeof e.post && e.post(a, f, C, o), d.render(a, C, r); p.length > 0;) {
        var _t5 = p.shift();

        _t5 && 'function' == typeof e[_t5] && e[_t5](a, f, C);
      }

      r.once || requestAnimationFrame(M), n(a);
    }
  });
}

function g(e, t, o, n) {
  var r = t.element.getBoundingClientRect(),
      l = t.cols || Math.floor(r.width / o.cellWidth),
      s = t.rows || Math.floor(r.height / o.lineHeight);
  return Object.freeze({
    frame: e.frame,
    time: e.time,
    cols: l,
    rows: s,
    metrics: o,
    width: r.width,
    height: r.height,
    settings: t,
    runtime: Object.freeze({
      cycle: e.cycle,
      fps: n.fps
    })
  });
}

function y(e) {
  e.style.userSelect = 'none', e.style.webkitUserSelect = 'none', e.style.mozUserSelect = 'none', e.dataset.selectionEnabled = 'false';
}

function w(e) {
  var t = 'false' == !e.dataset.selectionEnabled;
  t || function (e) {
    e.style.userSelect = 'auto', e.style.webkitUserSelect = 'auto', e.style.mozUserSelect = 'auto', e.dataset.selectionEnabled = 'true';
  }(e);
  var o = document.createRange();
  o.selectNode(e);
  var n = window.getSelection();
  n.removeAllRanges(), n.addRange(o), document.execCommand('copy'), n.removeAllRanges(), t || y(e);
}

function b(e) {
  var t = getComputedStyle(e),
      o = t.getPropertyValue('font-family'),
      n = parseFloat(t.getPropertyValue('line-height')),
      r = parseFloat(t.getPropertyValue('font-size'));
  var l;

  if ('CANVAS' == e.nodeName) {
    var _t6 = e.getContext('2d');

    _t6.font = r + 'px ' + o, l = _t6.measureText(''.padEnd(50, 'X')).width / 50;
  } else {
    var _t7 = document.createElement('span');

    e.appendChild(_t7), _t7.innerHTML = ''.padEnd(50, 'X'), l = _t7.getBoundingClientRect().width / 50, e.removeChild(_t7);
  }

  return {
    aspect: l / n,
    cellWidth: l,
    lineHeight: n,
    fontFamily: o,
    fontSize: r,
    _update: function _update() {
      var t = b(e);

      for (var _o6 in t) {
        'number' != typeof t[_o6] && 'string' != typeof t[_o6] || (m[_o6] = t[_o6]);
      }
    }
  };
}